import { ProfileCard } from './profile-card';
import { PopupProfileCard } from './popup-profile-card';
import { extractFieldInfo } from './utils';
import { StaffFieldsData } from './types';
export default {
    ProfileCard: ProfileCard,
    PopupProfileCard: PopupProfileCard,
    extractFieldInfo: extractFieldInfo,
};
